/* Haye Nii: "Seen on Instagram" rows + full-screen reels (task 28; task 33 = real-looking, per-video text, product pages).
   Owner 2026-10-16: "same as Instagram / TikTok reels". Creators gave permission for their videos.
   - The video list (assets/hayenii-reels.json, built by claude-tasks/tools/build-reels-v2.py) is fetched only when the
     row comes near the screen. Each video: product, who posted it, the month it was posted, a sharp cover picture.
   - Homepage (sections/hn-home-instagram.liquid): the row shows ONE clear video of each product (shuffled every
     visit); the full-screen feed then goes on with all other videos (shuffled, never the same product twice in a row).
   - Product page (sections/hn-product-reels.liquid, data-product): only that product's videos.
   - Full screen, like Instagram Reels: swipe up / down (mouse wheel, arrow keys, buttons on computers). Tap = sound
     on/off (also the speaker button top right), press and hold = 2x speed, thin progress line, close top left.
     Bottom left = only TRUE details of THIS video: @creator (or Haye Nii for our own clips) + month, one real review
     of the product as the "top comment" (tap = all reviews), the product card (tap = product page).
     Nothing is invented: no shared caption, no badges.
   - Right side: Reviews (all of that product's Judge.me reviews, shuffled, photos open big) and Share.
   - Close with X, Esc or the phone's Back button. Fail-safe: no list -> the section hides.
   Task 37 (owner 2026-10-17, "people don't know if they swipe right or up"): in full screen BOTH work - swipe up or
   swipe left = next video, down or right = back (arrow keys too). The first time on a phone the video lifts a little to
   show the next one with "Swipe up for more" (once per phone). Tap = pause / play (TikTok); pause and sound buttons
   sit together top right; the sound choice is shared with the story circles for this visit; a volume-up key turns the
   sound on where the browser passes it on (iPhone Safari never tells a web page). Homepage: tapping a video opens
   that video, then more videos of the SAME piece (up to 3), then everything else. The row nudges once per visit so
   people see it slides sideways. */
(function () {
  if (window.hnReelsLoaded) return;
  window.hnReelsLoaded = true;
  var ROW_CARDS = 60;
  var HOLD_MS = 280;
  var SNAP_IDLE_MS = 220; // after the last scroll movement, finish a swipe that stopped between two videos
  var SOUND_KEY = 'hn_sound'; // shared with the story circles (assets/hn-story-tiles.js)
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var api = function () { return window.hnReviews || null; };
  // The spin popup stays out of sight on this page once the shopper has opened the videos or the story circles (owner
  // 2026-10-18: it opened on its timer behind the videos and jumped out when they closed). CSS: hayenii-spin-skin.liquid.
  // PopSpin's show() adds its overlay, sets body overflow hidden ONCE (its scroll lock) and then the "open" attribute on
  // <spin-wheel-popup>. Only that one lock is taken off, at that moment, and only for a popup held out of sight; locks
  // from anything else (menu, cart, search, chat) are never touched. Same block in hayenii-reels.js and hn-story-tiles.js.
  var hnQuiet = window.hnQuiet || (window.hnQuiet = (function () {
    var on = false, watched = null, tries = 0;
    function freeIfHeld(p) { // the popup is open but out of sight: take off the scroll lock it just put on
      if (on && p.hasAttribute('open') && document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    }
    function watch() {
      var p = document.querySelector('spin-wheel-popup');
      if (!p) { if (++tries < 60) setTimeout(watch, 1000); return; } // PopSpin not on the page (yet)
      if (watched === p) return;
      watched = p;
      freeIfHeld(p); // it opened at the same moment
      if (window.MutationObserver) new MutationObserver(function () { freeIfHeld(p); }).observe(p, { attributes: true, attributeFilter: ['open'] });
    }
    function start() {
      if (on) return;
      on = true;
      document.documentElement.classList.add('hn-ps-quiet');
      watch();
    }
    return { start: start };
  })());
  // Which copy of a video a phone gets (speed round 2026-10-18; the same block is in hayenii-reels.js and
  // hn-story-tiles.js, the first one loaded is used by both). Shopify keeps 3 copies of every video with the same
  // number: 1080p, 720p and 480p (checked all 201). Computers: as uploaded. Phones: 720p, or 480p when the connection
  // is slow (measured from the videos and pictures this phone has already loaded), so the video never waits.
  var hnVideo = window.hnVideo || (window.hnVideo = (function () {
    var seen = []; // {u: video address, m: Mbps measured} for the last 4 videos
    var low = null; // true = 480p, false = 720p, null = not known yet
    function mbps() {
      if (seen.length) return Math.max.apply(null, seen.map(function (x) { return x.m; })); // 2 load at once: each sees part
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || ''))) return 1;
      try { // from the page's own big downloads (the Shopify CDN allows reading their timing; works on iPhone too)
        var r = [];
        performance.getEntriesByType('resource').forEach(function (e) {
          var ms = e.responseEnd - e.responseStart;
          if (e.transferSize > 60000 && ms > 40) r.push(e.transferSize * 8 / ms / 1000);
        });
        if (r.length > 1) { r.sort(function (a, b) { return a - b; }); return r[Math.floor(r.length / 2)]; }
      } catch (e) { /* no timing */ }
      return (c && c.downlink) || 0; // last: Chrome's own guess (often far too low on a fresh page)
    }
    function pick(url) {
      if (window.innerWidth >= 768 || !url) return url;
      var m = mbps();
      if (m) low = low ? m < 3 : m < 2; // a little room either way, so it does not flip back and forth
      var u = url.replace('.HD-1080p-2.5Mbps-', '.HD-720p-1.6Mbps-').replace('.HD-1080p-3.3Mbps-', '.HD-720p-2.1Mbps-');
      if (low) u = u.replace('.HD-720p-1.6Mbps-', '.SD-480p-0.9Mbps-').replace('.HD-720p-2.1Mbps-', '.SD-480p-1.0Mbps-');
      return u;
    }
    // called on the video's "progress": seconds of video loaded x its bitrate / time since it got its source
    function learn(v) {
      if (!v || !v.hnStart || !v.buffered || !v.buffered.length || !(v.duration > 0) || v.preload !== 'auto') return;
      var u = v.currentSrc || '';
      var secs = (performance.now() - v.hnStart) / 1000;
      var got = v.buffered.end(v.buffered.length - 1);
      var rate = /-(\d+(?:\.\d+)?)Mbps-/.exec(u);
      if (!rate || (secs < 1 && got < v.duration - 0.3)) return; // too early to tell (a whole short video counts)
      var m = (got - (v.hnGot0 || 0)) * parseFloat(rate[1]) / Math.max(secs, 0.25);
      for (var k = 0; k < seen.length; k++) if (seen[k].u === u) { seen[k].m = Math.max(seen[k].m, m); return; }
      seen.push({ u: u, m: m });
      if (seen.length > 4) seen.shift();
    }
    return { pick: pick, learn: learn };
  })());
  function store(kind, key, val) {
    try { var s = window[kind]; if (val === undefined) return s.getItem(key); s.setItem(key, val); } catch (e) { /* private mode */ }
    return null;
  }

  function esc(text) {
    return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function shuffle(list) {
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13M16 5.5v13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // outline icons drawn like Instagram's (round speech bubble, paper plane), same 1.9 stroke everywhere
    chat: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 17.4A9.2 9.2 0 1 0 17 20.5L21.5 21.5z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/></svg>',
    share: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.5 3.5L10.2 13.3M21.5 3.5l-7 17.6-4.3-7.8-7.7-4.3z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" stroke-linecap="round"/></svg>',
    mute: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.5h3.8L12 5.2v13.6l-4.7-4.3H3.5z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.5h3.8L12 5.2v13.6l-4.7-4.3H3.5z" fill="currentColor"/><path d="M15.5 9a4.2 4.2 0 0 1 0 6M18.2 6.4a8 8 0 0 1 0 11.2" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    star: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9l-5.2 2.8 1-5.9L1.5 7.7l5.9-.8z"/></svg>'
  };

  // "2024-06" -> "Jun 2024" (the month the video was posted on Instagram; empty when unknown)
  function month(d) {
    var m = /^(\d{4})-(\d{2})$/.exec(d || '');
    if (!m) return '';
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+m[2] - 1] + ' ' + m[1];
  }
  function isBrand(v) { return !/^@/.test(v.who); }
  // name necklace family (one necklace listed per language): which language this video's listing is
  var LANGS = { punjabi: 'Punjabi', hindi: 'Hindi', arabic: 'Arabic/Urdu', english: 'English', bengali: 'Bengali',
    gujarati: 'Gujarati', tamil: 'Tamil', telugu: 'Telugu', kannada: 'Kannada', malayalam: 'Malayalam', sinhala: 'Sinhala' };
  function lang(h) { var m = /punjabi|hindi|arabic|english|bengali|gujarati|tamil|telugu|kannada|malayalam|sinhala/.exec(h); return m ? LANGS[m[0]] : ''; }
  // row cards are small: ask Shopify's CDN for a 360 px picture (it also sends WebP/AVIF to phones that take it)
  function small(src) { return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=360'; }
  // top comments (checker 33-2/33-3): per product, the ids of reviews Judge.me collected for THIS store (build script),
  // and ONE random number per product per visit, so the videos of one product show different reviews
  var okFor = {}, seedFor = {};
  function seed(h) { if (!(h in seedFor)) seedFor[h] = Math.floor(Math.random() * 1000); return seedFor[h]; }
  // task 36 (owner 2026-10-17): the name necklace is ONE necklace listed per language. On those pages the top comments
  // come from ONE shared list of the whole family, newest first ([review id, product id], built by the script).
  // Product pages: newest first too (the lists are newest first). Homepage: still a new mix on every visit.
  var groupOk = [];
  var MAIN = 'namelicious-personalized-name-necklace';
  function handle(v) { return isBrand(v) ? 'Haye Nii' : v.who; }

  // ---------- the homepage row ----------
  function card(v, i) {
    var when = month(v.d);
    return '<article class="hn-rev hn-rev--ig" role="listitem" data-i="' + i + '">' +
      '<button type="button" class="hn-rev__pic hn-ig__media" aria-label="Play video by ' + esc(handle(v)) + (when ? ', ' + esc(when) : '') + ', of the ' + esc(v.product.t) + '">' +
      '<img src="' + esc(small(v.cover)) + '" alt="" loading="lazy" decoding="async" width="270" height="480">' +
      '<span class="hn-ig__play">' + ICON.play + '</span><span class="hn-ig__who">' + esc(handle(v)) + '</span></button>' +
      (v.mode === 'product' || v.mode === 'family' ? '' : prodRow(v)) + '</article>';
  }
  function prodRow(v) {
    return '<a class="hn-rev__prod" href="/products/' + esc(v.h) + '">' +
      (v.product.i ? '<img src="' + esc(v.product.i) + '" alt="" loading="lazy" decoding="async" width="44" height="44">' : '') +
      '<span class="hn-rev__prod-name">' + esc(v.product.t) + '</span>' +
      '<span class="hn-rev__prod-go" aria-hidden="true">' + ICON.arrow + '</span></a>';
  }

  // rowList = the cards in the row; feed = what the full-screen reels play (the row first, then the rest)
  // all = every video on this page (homepage): a tap opens that video, then the row's next videos (one per product, so
  // the first ~37 are all different pieces), then the rest, never the same piece twice in a row (owner 2026-10-18;
  // replaces task 37's "3 more of the same piece")
  function related(v, rowList, all) {
    var k = rowList.indexOf(v);
    var next = rowList.slice(k + 1).concat(rowList.slice(0, k)).filter(function (x) { return x !== v; });
    var used = [v].concat(next);
    var rest = all.filter(function (x) { return used.indexOf(x) < 0; });
    return used.concat(spread(rest, used[used.length - 1].h));
  }

  // Phones: when the row first comes into view, the cards slide a little to the left and back (once per visit)
  function nudge(box, key) {
    if (!('IntersectionObserver' in window) || REDUCED || window.matchMedia('(hover: hover)').matches) return;
    if (store('sessionStorage', key)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var rowEl = box.querySelector('.hn-revs');
      if (!rowEl || rowEl.scrollWidth <= rowEl.clientWidth + 8 || rowEl.scrollLeft > 4) return;
      store('sessionStorage', key, '1');
      setTimeout(function () { rowEl.classList.add('hn-revs--hint'); }, 400);
      rowEl.addEventListener('pointerdown', function () { rowEl.classList.remove('hn-revs--hint'); }, { once: true });
    }, { threshold: 0.6 });
    io.observe(box);
  }

  function row(section, rowList, feed, all) {
    var box = section.querySelector('[data-hn-ig-row]');
    var shown = rowList.slice(0, ROW_CARDS);
    box.innerHTML = '<div class="hn-revs" role="list" aria-label="Instagram videos">' + shown.map(card).join('') + '</div>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--prev" aria-label="Previous">' + ICON.arrow + '</button>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--next" aria-label="Next">' + ICON.arrow + '</button>';
    var rowEl = box.querySelector('.hn-revs');
    var prev = box.querySelector('.hn-revs__arrow--prev');
    var next = box.querySelector('.hn-revs__arrow--next');
    function arrows() {
      prev.hidden = rowEl.scrollLeft <= 2;
      next.hidden = rowEl.scrollLeft >= rowEl.scrollWidth - rowEl.clientWidth - 2;
    }
    rowEl.addEventListener('scroll', arrows, { passive: true });
    arrows();
    box.addEventListener('click', function (event) {
      var arrow = event.target.closest('.hn-revs__arrow');
      if (arrow) {
        rowEl.scrollBy({ left: (arrow === prev ? -1 : 1) * rowEl.clientWidth * 0.9, behavior: 'smooth' });
        return;
      }
      if (event.target.closest('a')) return; // product row: go to the product
      var c = event.target.closest('.hn-rev[data-i]');
      if (!c) return;
      if (all) reels.open(related(shown[+c.dataset.i], rowList, all), 0, c.querySelector('button'));
      else reels.open(feed, +c.dataset.i, c.querySelector('button'));
    });
    section.classList.add('hn-hr--ready');
    if (!section.dataset.product) nudge(box, 'hn_hint_ig');
  }

  // ---------- reviews per product: first page fast, the rest in the background ----------
  var reviewStore = {};
  function reviewsFor(p) {
    if (!p.id) return null;
    var s = reviewStore[p.id];
    if (s) return s;
    var A = api();
    if (!A || !A.stream) return null;
    s = reviewStore[p.id] = { list: [], total: 0, first: false, done: false, failed: false, listeners: [] };
    A.stream(p.id, function (batch, total) {
      s.list = s.list.concat(batch);
      s.total = total;
      s.first = true;
      s.listeners.forEach(function (fn) { fn(batch); });
    }).then(function () { s.done = true; s.listeners.forEach(function (fn) { fn([]); }); })
      .catch(function () { s.failed = !s.first; s.done = true; s.listeners.forEach(function (fn) { fn([]); }); if (s.failed) delete reviewStore[p.id]; });
    return s;
  }

  // ---------- full-screen reels ----------
  var reels = (function () {
    var el, feed, sheet, photo, toast, list = [], at = 0, muted = store('sessionStorage', SOUND_KEY) !== '1', back = null, pushed = false, backPending = false, scrollTimer;
    var paused = false; // the shopper tapped pause (the next video plays again)
    var swipe = null; // a finger on the video: sideways swipes also change the video
    var touching = false, alignTimer, alignTries = 0, goal = -1;
    var hold = { timer: 0, on: false, used: false };

    function build() {
      el = document.createElement('div');
      el.className = 'hn-reels';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Instagram videos');
      el.innerHTML = '<div class="hn-reels__stage"><div class="hn-reels__feed" tabindex="-1"></div>' +
        '<button type="button" class="hn-reels__close" aria-label="Close videos">' + ICON.close + '</button>' +
        '<div class="hn-reels__ctrl"><button type="button" class="hn-reels__pause" data-pause aria-label="Pause video">' + ICON.pause + '</button>' +
        '<button type="button" class="hn-reels__sound" data-sound aria-label="Turn sound on" aria-pressed="false">' + ICON.mute + '</button></div>' +
        '<p class="hn-reels__hint" aria-hidden="true" hidden>' + ICON.up + '<span>Swipe up for more</span></p>' +
        '<div class="hn-reels__steps"><button type="button" class="hn-reels__step" data-step="-1" aria-label="Previous video">' + ICON.up + '</button>' +
        '<button type="button" class="hn-reels__step" data-step="1" aria-label="Next video">' + ICON.down + '</button></div>' +
        '<div class="hn-reels__sheet" hidden role="dialog" aria-label="Reviews"><div class="hn-reels__sheet-head"><button type="button" class="hn-reels__grab" aria-label="Show all reviews" aria-expanded="false"></button>' +
        '<p class="hn-reels__sheet-title"></p><p class="hn-reels__sheet-sub"></p>' +
        '<button type="button" class="hn-reels__sheet-close" aria-label="Close reviews">' + ICON.close + '</button></div>' +
        '<div class="hn-reels__sheet-list"></div>' +
        // fix 2026-10-20 (owner's iPhone: "try to close comments ... it opens up products"): the Shop row sat right under
        // the X and inside the drag area; now it is at the bottom of the sheet, away from the X and the handle
        '<div class="hn-reels__sheet-foot"><a class="hn-reels__sheet-shop" href="/"><img alt="" width="36" height="36" decoding="async"><span class="hn-reels__sheet-shop-name"></span>' +
        '<span class="hn-reels__sheet-shop-go">Shop' + ICON.arrow + '</span></a></div></div>' +
        '<div class="hn-reels__photo" hidden role="dialog" aria-label="Review photo"><div class="hn-reels__photo-strip"></div>' +
        '<button type="button" class="hn-reels__photo-close" aria-label="Close photo">' + ICON.close + '</button></div>' +
        '<p class="hn-reels__toast" role="status" hidden></p><div class="hn-reels__pool" hidden></div></div>';
      document.body.appendChild(el);
      feed = el.querySelector('.hn-reels__feed');
      sheet = el.querySelector('.hn-reels__sheet');
      photo = el.querySelector('.hn-reels__photo');
      toast = el.querySelector('.hn-reels__toast');
      spare = el.querySelector('.hn-reels__pool');
      for (var k = 0; k < POOL; k++) spare.appendChild(newVideo());
      el.addEventListener('click', onClick);
      feed.addEventListener('scroll', function () {
        if (at >= 0 && nearest() !== at) settle(); // more than half of the next video is on screen: it plays now
        roll();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(settle, 90);
        later(SNAP_IDLE_MS);
      }, { passive: true });
      // Snap guard (task 33 bug fix): phones (iPhone Safari above all) sometimes stop a swipe BETWEEN two videos (the
      // toolbar changed the screen height, a fast flick, the app came back from the background). CSS snapping does not
      // always finish there, so after every swipe we check and finish it ourselves. Never while a finger is down.
      feed.addEventListener('touchstart', function (event) {
        touching = true; goal = -1; clearTimeout(alignTimer);
        stopHint();
        var t = event.touches[0];
        swipe = event.touches.length === 1 ? { x: t.clientX, y: t.clientY, at: Date.now() } : null;
      }, { passive: true });
      var lift = function () { touching = false; later(SNAP_IDLE_MS); };
      feed.addEventListener('touchend', function (event) {
        // task 37: a sideways swipe also moves (left = next, right = back), so nobody is stuck guessing the direction
        var s = swipe, t = event.changedTouches[0];
        swipe = null;
        lift();
        bless();
        if (!s || !t || Date.now() - s.at > 900) return;
        var dx = t.clientX - s.x, dy = t.clientY - s.y;
        if (sheetOpen()) return; // reviews open: the feed stands still (the swipe closes the reviews, below)
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) { hold.used = true; go(dx < 0 ? 1 : -1); }
      }, { passive: true });
      feed.addEventListener('touchcancel', function () { swipe = null; lift(); }, { passive: true });
      feed.addEventListener('scrollend', function () { later(60); });
      // reviews open: a swipe on the small video or the black around it closes the reviews (Instagram)
      var away = null;
      el.addEventListener('touchstart', function (event) {
        var t = event.touches[0];
        away = sheetOpen() && event.touches.length === 1 && !event.target.closest('.hn-reels__sheet, .hn-reels__photo') ? { x: t.clientX, y: t.clientY } : null;
      }, { passive: true });
      el.addEventListener('touchend', function (event) {
        var a = away, t = event.changedTouches[0];
        away = null;
        if (a && t && sheetOpen() && (Math.abs(t.clientX - a.x) > 30 || Math.abs(t.clientY - a.y) > 30)) { quiet(); closeSheet(); }
      }, { passive: true });
      // computers: the mouse wheel does not move the feed while the reviews are open
      feed.addEventListener('wheel', function (event) { if (sheetOpen()) event.preventDefault(); }, { passive: false });
      dragSheet();
      var refit = function () {
        if (!el || el.hidden) return;
        clearTimeout(refit.t);
        refit.t = setTimeout(function () { jump(); if (sheetOpen()) makeRoom(); }, 120);
      };
      window.addEventListener('resize', refit);
      window.addEventListener('orientationchange', refit);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', refit);
      document.addEventListener('visibilitychange', function () {
        if (!el || el.hidden) return;
        var v = current();
        if (document.hidden) { if (v) v.pause(); return; }
        jump();
        if (v && !paused) playNow(v);
      });
      feed.addEventListener('progress', function (event) { hnVideo.learn(event.target); }, true);
      // progress bar (media events don't bubble, but they reach a capturing ancestor)
      feed.addEventListener('timeupdate', function (event) {
        var v = event.target;
        if (!v.duration) return;
        var bar = v.closest('.hn-reel').querySelector('.hn-reel__bar i');
        if (bar) bar.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')';
      }, true);
      // press and hold = 2x speed (like TikTok); a short tap = pause / play (task 37)
      feed.addEventListener('pointerdown', function (event) {
        if (sheetOpen() || !event.target.closest('.hn-reel__video, .hn-reel__poster, .hn-reel__tap')) return;
        hold.used = false;
        hold.x = event.clientX; hold.y = event.clientY;
        clearTimeout(hold.timer);
        hold.timer = setTimeout(function () {
          var v = current();
          if (!v) return;
          hold.on = hold.used = true;
          if (paused) setPaused(false);
          v.playbackRate = 2;
          if (v.paused) v.play().catch(function () {});
          v.closest('.hn-reel').classList.add('hn-reel--fast');
        }, HOLD_MS);
      });
      // a finger that moves is a swipe, never a hold (sideways swipes are not scrolling, so no pointercancel comes)
      feed.addEventListener('pointermove', function (event) {
        if (!hold.on && (Math.abs(event.clientX - hold.x) > 12 || Math.abs(event.clientY - hold.y) > 12)) clearTimeout(hold.timer);
      });
      var release = function () {
        clearTimeout(hold.timer);
        if (!hold.on) return;
        hold.on = false;
        feed.querySelectorAll('video').forEach(function (v) { if (v.hnWarm !== 'on') v.playbackRate = 1; });
        feed.querySelectorAll('.hn-reel--fast').forEach(function (s) { s.classList.remove('hn-reel--fast'); });
      };
      feed.addEventListener('pointerup', release);
      feed.addEventListener('pointercancel', release); // a swipe started: never stay at 2x
      feed.addEventListener('pointerleave', release);
      feed.addEventListener('contextmenu', function (event) { if (event.target.closest('.hn-reel')) event.preventDefault(); });
      // photo strip: horizontal swipe between a review's photos is native scrolling
      document.addEventListener('keydown', onKey);
      window.addEventListener('popstate', function () {
        if (backPending) { backPending = false; if (!el.hidden) push(); return; }
        if (!photo.hidden) { closePhoto(); push(); return; }
        if (sheetOpen()) { closeSheet(); push(); return; }
        if (!el.hidden) close(true);
      });
    }

    function slide(v, i) {
      var p = v.product; // the listing the video belongs to (its reviews)
      var c = v.card || p; // the product card (family: this page's necklace - it is the same necklace)
      var cardH = v.cardH || v.h;
      var when = month(v.d);
      var language = v.mode === 'family' ? lang(v.h) : '';
      var rp = v.rev || p; // whose reviews the Reviews button opens
      var count = rp.c ? '<span class="hn-reel__label">' + rp.c + '</span>' : '';
      return '<img class="hn-reel__poster" data-src="' + esc(v.cover) + '" alt="" decoding="async">' +
        '<span class="hn-reel__tap" aria-hidden="true"></span>' +
        '<span class="hn-reel__speed" aria-hidden="true">2× speed</span>' +
        '<span class="hn-reel__flash" aria-hidden="true"></span>' +
        '<div class="hn-reel__rail">' +
        '<button type="button" class="hn-reel__btn" data-reviews aria-label="' + (rp.c ? rp.c + ' reviews' : 'Reviews') + ' of the ' + esc(rp.t) + '">' + ICON.chat + count + '</button>' +
        '<button type="button" class="hn-reel__btn" data-share aria-label="Share the ' + esc(p.t) + '">' + ICON.share + '</button>' +
        '</div>' +
        '<div class="hn-reel__info">' +
        '<p class="hn-reel__who"><span class="hn-reel__avatar' + (isBrand(v) ? ' hn-reel__avatar--brand' : '') + '" aria-hidden="true">' +
        esc((isBrand(v) ? 'H' : v.who.replace(/^@/, '').charAt(0)).toUpperCase()) + '</span>' +
        '<b>' + esc(handle(v)) + '</b>' + (when ? '<span class="hn-reel__when">' + esc(when) + '</span>' : '') +
        '</p>' +
        '<button type="button" class="hn-reel__top" data-reviews hidden></button>' +
        '<a class="hn-reel__prod" href="/products/' + esc(cardH) + '">' +
        (c.i ? '<img src="' + esc(c.i) + '" alt="" width="40" height="40" loading="lazy">' : '') +
        '<span class="hn-reel__prod-text"><span class="hn-reel__prod-name">' + esc(c.t) + '</span>' +
        (language ? '<small class="hn-reel__prod-lang">' + 'Video: ' + esc(language) + ' name</small>' : '') + '</span>' +
        '<span class="hn-reel__prod-go">Shop' + ICON.arrow + '</span></a>' +
        '</div>' +
        '<div class="hn-reel__bar" aria-hidden="true"><i></i></div>';
    }

    // Speed round (2026-10-18): the feed starts as 201 empty frames (same height, so swiping works the same) and only
    // the videos near the screen are built. Building all 201 at once took 2 s on a mid-range phone before the first
    // video even started loading.
    // iPhone sound (owner 2026-10-19: "audio is turning off after every 3rd video"): iPhone lets a video player play
    // sound only once the shopper has tapped while that player existed. New players made later were refused, so after
    // every tap on the sound button the 3rd video after it went silent. Now POOL players are made once, when the viewer
    // is built, and moved from video to video (at most 4 are in use); every tap gives all of them the right to sound.
    var POOL = 6, spare = null;
    function newVideo() {
      var v = document.createElement('video');
      v.className = 'hn-reel__video';
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.loop = true;
      v.muted = true;
      v.defaultMuted = true;
      v.preload = 'none';
      return v;
    }
    function attach(n) { // video n gets a player
      var s = feed.querySelector('.hn-reel[data-i="' + n + '"]');
      if (!s || !s.hnBuilt || s.querySelector('video')) return;
      var v = (spare && spare.querySelector('video')) || newVideo();
      delete v.dataset.fit;
      v.muted = true;
      v.setAttribute('aria-label', 'Video by ' + handle(list[n]) + ' of the ' + list[n].product.t);
      var poster = s.querySelector('.hn-reel__poster');
      s.insertBefore(v, poster ? poster.nextSibling : s.firstChild);
    }
    function release(v) { // its video is far away now: the player goes back to the spares, empty
      var s = v.closest('.hn-reel');
      stop(v);
      if (s) s.classList.remove('hn-reel--playing');
      if (spare) spare.appendChild(v);
    }
    // a tap (or a finger lifted after a swipe) while the sound is on: every player gets the right to sound now
    function bless() {
      if (muted || !el) return;
      var cur = current();
      el.querySelectorAll('video').forEach(function (v) {
        if (v === cur || !v.muted) return;
        v.muted = false;
        v.muted = true;
      });
    }

    function make(n) {
      var s = feed.querySelector('.hn-reel[data-i="' + n + '"]');
      if (!s || s.hnBuilt) return;
      s.hnBuilt = true;
      if (list[n].wide) s.classList.add('hn-reel--wide');
      s.innerHTML = slide(list[n], n);
    }

    // The "top comment" under a video: one REAL review of its product, chosen from the ids the build script allows
    // (only reviews Judge.me collected for this store; imported ones never). Video 0, 1, 2 ... of the same product
    // take ids (seed + 0), (seed + 1) ... so they never repeat; with fewer reviews than videos, the extra videos get none.
    function fillTop(n) {
      var s = feed.querySelector('.hn-reel[data-i="' + n + '"]');
      var v = list[n];
      if (!s || !v || s.hnTop || !s.hnBuilt) return;
      var want, store;
      if (v.fam) { // whole family, newest first: video 0 gets the newest review, video 1 the next ...
        var g = groupOk[n];
        if (!g) { s.hnTop = true; return; }
        want = g[0];
        store = reviewsFor({ id: g[1] });
      } else {
        var ids = okFor[v.h] || [];
        var k = 0;
        for (var j = 0; j < n; j++) if (list[j].h === v.h) k++;
        if (k >= ids.length) { s.hnTop = true; return; }
        want = ids[v.mode === 'home' ? (k + seed(v.h)) % ids.length : k];
        store = reviewsFor(v.product);
      }
      if (!store) return;
      var r = null;
      store.list.some(function (x) { if (x.id === want) { r = x; return true; } return false; });
      if (!r) {
        if (store.done) { s.hnTop = true; return; } // hidden in Judge.me since the list was built: no top comment
        if (!store.hnWaiting) {
          store.hnWaiting = true;
          store.listeners.push(function again() {
            store.hnWaiting = false;
            store.listeners = store.listeners.filter(function (fn) { return fn !== again; });
            [at - 1, at, at + 1].forEach(function (m) { if (m >= 0 && m < list.length) fillTop(m); });
          });
        }
        return;
      }
      s.hnTop = true;
      if (r.score && r.score < 3) return; // owner 2026-10-17: never a 1-2 star review as the top comment
      var name = String(r.name || '').trim();
      if (!name || /@|\d{3,}/.test(name)) name = 'Customer';
      var text = r.body || r.title;
      var top = s.querySelector('.hn-reel__top');
      // brand audit 2 (#3): say plainly this is a customer's review, not the creator's words
      top.innerHTML = '<span class="hn-reel__top-head"><span class="hn-reel__top-kind">Customer review</span>' +
        '<span class="hn-reel__top-stars" role="img" aria-label="' + r.score + ' out of 5 stars">' +
        new Array(r.score + 1).join(ICON.star) + '</span></span>' +
        '<span class="hn-reel__top-text"><b>' + esc(name) + '</b> ' + esc(text) + '</span>';
      top.setAttribute('aria-label', 'Customer review by ' + name + ': ' + text.slice(0, 80) + '. Open all reviews');
      top.dataset.rid = r.id || '';
      top.hnReview = r; // the sheet shows it first, even when it belongs to another listing of the same necklace
      top.hidden = false;
    }

    function open(videos, start, from) {
      if (!el) build();
      list = videos;
      back = from || null;
      feed.innerHTML = list.map(function (v, i) { return '<section class="hn-reel" data-i="' + i + '"></section>'; }).join('');
      el.hidden = false;
      document.documentElement.classList.add('hn-reels-open');
      hnQuiet.start();
      closeSheet(true);
      closePhoto();
      at = -1;
      feed.scrollTop = topOf(start);
      settle(start);
      bless(); // opened by a tap: the players may have sound
      el.querySelector('.hn-reels__close').focus({ preventScroll: true });
      if (!backPending) push();
      soundHint();
      clearTimeout(hintTimer);
      if (list.length > 1) hintTimer = setTimeout(swipeHint, 1400);
    }

    // First muted video of the visit: the sound button glows twice (shared with the story circles)
    function soundHint() {
      if (!muted || REDUCED || store('sessionStorage', 'hn_sound_hint')) return;
      store('sessionStorage', 'hn_sound_hint', '1');
      var b = el.querySelector('.hn-reels__sound');
      b.classList.remove('hn-reels__sound--hint');
      void b.offsetWidth;
      b.classList.add('hn-reels__sound--hint');
    }

    // First time on a phone: the video lifts a little to show the next one, with "Swipe up for more" (once per phone)
    var hintTimer, hintOff;
    function swipeHint() {
      if (!el || el.hidden || touching || REDUCED || sheetOpen() || at !== nearest() || at >= list.length - 1) return;
      if (!(window.matchMedia && window.matchMedia('(hover: none)').matches)) return; // computers have the arrows
      if (store('localStorage', 'hn_reels_hint')) return;
      store('localStorage', 'hn_reels_hint', '1');
      el.classList.add('hn-reels--peek');
      el.querySelector('.hn-reels__hint').hidden = false;
      hintOff = setTimeout(stopHint, 2600);
    }
    function stopHint() {
      clearTimeout(hintTimer);
      clearTimeout(hintOff);
      if (!el) return;
      el.classList.remove('hn-reels--peek');
      el.querySelector('.hn-reels__hint').hidden = true;
    }

    function push() {
      try { history.pushState({ hnReels: true }, ''); pushed = true; } catch (e) { pushed = false; }
    }

    function close(fromBack) {
      if (!el || el.hidden) return;
      feed.querySelectorAll('video').forEach(release);
      rolling = -1;
      stopHint();
      closePhoto();
      closeSheet(true);
      clearTimeout(alignTimer);
      touching = false;
      goal = -1;
      el.hidden = true;
      document.documentElement.classList.remove('hn-reels-open');
      if (back) back.focus({ preventScroll: true });
      if (pushed && !fromBack && history.state && history.state.hnReels) { backPending = true; history.back(); }
      pushed = false;
      feed.innerHTML = '';
    }

    function stop(v) {
      v.hnWarmToken = null; v.hnWarm = false; v.hnRoll = false;
      try { v.pause(); v.playbackRate = 1; if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); } } catch (e) { /* gone */ }
    }

    // The video on screen plays; its neighbours get a source (ready to play), others are emptied.
    function settle(force) {
      var i = typeof force === 'number' ? force : nearest();
      i = Math.max(0, Math.min(list.length - 1, i));
      if (i === at) return;
      at = i;
      handOver();
      closeSheet();
      setPaused(false, true); // a new video always plays (started just below)
      if (i > 0) stopHint();
      // Speed round (2026-10-18): the cover picture is only given to the videos near the screen. Before, every one of
      // the 201 videos got its cover at once (10.7 MB of pictures) and the first video waited 13-16 s on phone data.
      // The one on screen gets its cover now, the neighbours once it plays (warm, below)
      feed.querySelectorAll('.hn-reel video').forEach(function (v) {
        var n = +v.closest('.hn-reel').dataset.i;
        if (n < i - 1 || n > i + 2) release(v);
      });
      [i, i + 1, i - 1, i + 2].forEach(function (n) { if (n >= 0 && n < list.length) { make(n); attach(n); } });
      cover(i);
      feed.querySelectorAll('.hn-reel').forEach(function (s) {
        var n = +s.dataset.i;
        var v = s.querySelector('video');
        if (!v) return; // not built yet
        if (n === i + 2) { if (v.hnWarm !== 'on') v.pause(); s.classList.remove('hn-reel--playing'); return; } // keeps its head start
        if (Math.abs(n - i) > 1) { release(v); return; }
        // the one on screen loads fully; the next one too, but only once the one on screen plays (warm, below), so the
        // first video has the whole connection; the one before only its size (owner 2026-10-18: swipes paused)
        var ahead = n === i + 1 && !(curReady(i));
        if (!v.getAttribute('src')) { v.preload = n === i || (n === i + 1 && !ahead) ? 'auto' : 'metadata'; give(v, list[n]); }
        else if (n === i + 1 && !ahead) full(v);
        if (n === i) {
          full(v);
          v.muted = muted;
          v.playbackRate = 1;
          fit(v);
          playNow(v);
          s.classList.add('hn-reel--playing');
        } else {
          if (v.hnWarm !== 'on') v.pause(); // a video getting its head start (below the screen, no sound) keeps going
          s.classList.remove('hn-reel--playing');
        }
      });
      // Reviews (sheet + top comments) only once this video plays: every swipe is a new product now, and loading its
      // reviews at the same moment held up the video on phone data. The next video gets its head start first.
      var curV = feed.querySelector('.hn-reel[data-i="' + i + '"] video');
      afterStart(curV, function () {
        if (at !== i) return;
        [i + 1, i - 1, i + 2].forEach(cover);
        // the next video gets its first seconds ready, then the one after it (fast flicks land there), one at a time
        warm(vid(i + 1), i + 1, function () {
          if (at !== i) return;
          var v2 = i + 2 < list.length && vid(i + 2);
          if (!v2) return;
          if (!v2.getAttribute('src')) give(v2, list[i + 2]);
          warm(v2, i + 2);
        });
      }, 400, 4000);
      afterStart(curV, function () {
        if (at !== i) return;
        reviewsFor(list[i].rev || list[i].product); // ready before the shopper opens the sheet
        fillTop(i);
        setTimeout(function () {
          if (at !== i) return;
          [i - 1, i + 1].forEach(function (n) { if (n >= 0 && n < list.length) fillTop(n); });
        }, 600);
      }, 3000, 6000); // 3 s of playing first (a tap on Reviews loads them at once)
      sound();
      steps();
    }

    // iPhone round (owner 2026-10-18, real iPhone on phone data: "1 to 2 second pause" on every swipe). iPhone Safari
    // loads (almost) nothing for a video that is not playing, and it only starts a video once it thinks it can keep
    // going. So the next video PLAYS without sound below the screen until its first WARM_S seconds are loaded, then it
    // waits. It plays in slow motion (WARM_RATE), so in those seconds it moves only a few tenths of a second and never has
    // to jump back (a jump back made Chrome load the start again). Started only after the video on screen plays (they
    // never fight for the connection); the one after it comes next. A warm video that comes on screen just plays on.
    var WARM_S = 3;
    var WARM_RATE = 0.1;
    function readyFromStart(v) { // seconds loaded from the start of the video
      try { var b = v.buffered; for (var k = 0; k < b.length; k++) if (b.start(k) <= 0.3) return b.end(k); } catch (e) { /* none */ }
      return 0;
    }
    function warmEnough(v) { return readyFromStart(v) >= Math.min(WARM_S, (v.duration || 99) - 0.3); }
    function warm(v, n, then) {
      var next = function () { if (then) then(); };
      if (!v || !v.getAttribute('src')) return next();
      full(v);
      if (v.hnWarm || warmEnough(v)) { if (!v.hnWarm) v.hnWarm = 'done'; return next(); }
      var token = {};
      v.hnWarm = 'on';
      v.hnWarmToken = token;
      v.muted = true;
      try { v.playbackRate = WARM_RATE; } catch (e) { /* this phone: normal speed */ }
      var t0 = performance.now();
      var timer = setInterval(check, 250);
      v.addEventListener('progress', check);
      v.addEventListener('timeupdate', check);
      function end() {
        clearInterval(timer);
        v.removeEventListener('progress', check);
        v.removeEventListener('timeupdate', check);
      }
      function check() {
        if (v.hnWarmToken !== token) return end(); // got a new source meanwhile
        var mine = at === n || v.hnRoll; // on screen now / sliding in: it keeps playing
        if (!mine && !warmEnough(v) && performance.now() - t0 < 8000 && v.currentTime < 1.2) return;
        end();
        v.hnWarm = 'done';
        if (!mine) {
          v.pause();
          if (v.currentTime > 1) { try { v.currentTime = 0; } catch (e) { /* not ready */ } } // normal speed on this phone
        }
        v.playbackRate = 1;
        next();
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () { if (v.hnWarmToken === token) { end(); v.hnWarm = 'done'; next(); } }); // refused (Low Power Mode)
    }

    // Instagram: the next video is already moving while it slides in. As soon as the shopper starts a swipe, the warm
    // video that comes in starts playing (no sound); a swipe given up puts it back on its first picture. Also with the
    // sound on (owner's iPhone, 2026-10-19: with sound on every swipe waited ~1 s, rolling ones were instant): it rolls
    // silently and gets its sound the moment it becomes the video on screen (settle -> playNow).
    var rolling = -1, lastTop = 0;
    function roll() {
      var top = feed.scrollTop, dy = top - lastTop;
      lastTop = top;
      if (at < 0) return;
      var f = top / slideH() - at;
      var n = f > 0.06 ? at + 1 : f < -0.06 ? at - 1 : -1;
      if (n === rolling) return;
      // only a video the feed is moving TOWARDS starts (not the one sliding away after the swipe passed half-way)
      if (n >= 0 && (n > at ? dy <= 0 : dy >= 0)) n = -1;
      if (n === rolling) return;
      unroll();
      var v = n >= 0 && n < list.length && vid(n);
      if (!v || !v.getAttribute('src') || v.readyState < 2) return;
      rolling = n;
      v.hnRoll = true;
      v.muted = true;
      v.playbackRate = 1;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* stays on its first picture */ });
    }
    function unroll() {
      if (rolling < 0) return;
      var v = vid(rolling);
      rolling = -1;
      if (!v) return;
      v.hnRoll = false;
      if (v.hnWarm !== 'on') { v.pause(); try { if (v.currentTime > 0.5) v.currentTime = 0; } catch (e) { /* not ready */ } }
    }
    function handOver() { // the swipe finished on a new video: the one that was rolling in is now simply the video on screen
      if (rolling < 0) return;
      var v = vid(rolling);
      if (v) v.hnRoll = false;
      rolling = -1;
    }
    function vid(n) { return feed.querySelector('.hn-reel[data-i="' + n + '"] video'); }

    // a video that had only its size now loads fully; the speed measure starts again from here
    function full(v) {
      if (v.preload === 'auto') return;
      v.preload = 'auto';
      v.hnStart = performance.now();
      v.hnGot0 = v.buffered && v.buffered.length ? v.buffered.end(v.buffered.length - 1) : 0;
    }

    function curReady(i) {
      var v = feed.querySelector('.hn-reel[data-i="' + i + '"] video');
      return !!v && v.readyState >= 3;
    }

    // the right copy of the video for this phone and its connection (hnVideo, below); a missing copy -> the original
    function give(v, item) {
      var url = hnVideo.pick(item.v);
      v.hnStart = performance.now();
      v.hnGot0 = 0;
      v.hnWarm = false;
      v.hnWarmToken = null;
      v.hnRoll = false;
      v.onerror = url === item.v ? null : function () { v.onerror = null; v.setAttribute('src', item.v); };
      v.setAttribute('src', url);
    }

    function cover(n) {
      var img = feed.querySelector('.hn-reel[data-i="' + n + '"] .hn-reel__poster');
      if (img && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
    }

    // run fn shortly (delay) after video v really plays, or after maxWait at most (paused, autoplay refused)
    function afterStart(v, fn, delay, maxWait) {
      var done = false;
      var go = function () { if (done) return; done = true; if (v) v.removeEventListener('playing', go); setTimeout(fn, delay || 250); };
      if (!v || (!v.paused && v.readyState >= 3)) return go();
      v.addEventListener('playing', go);
      setTimeout(go, maxWait || 1500);
    }

    // tall (phone) videos fill the screen; square or wide ones are shown whole
    function fit(v) {
      if (v.dataset.fit) return;
      var set = function () {
        if (!v.videoWidth) return;
        v.dataset.fit = v.videoWidth / v.videoHeight > 0.75 ? 'contain' : 'cover';
        v.closest('.hn-reel').classList.toggle('hn-reel--wide', v.dataset.fit === 'contain');
      };
      if (v.readyState >= 1) set(); else v.addEventListener('loadedmetadata', set, { once: true });
    }

    function steps() {
      var b = el.querySelectorAll('.hn-reels__step');
      b[0].disabled = at <= 0;
      b[1].disabled = at >= list.length - 1;
    }

    function go(dir) {
      if (sheetOpen()) return closeSheet(); // the reviews close first; the next press moves
      // quick presses add up (3 taps on the arrow = 3 videos on), even before the glide has finished
      var i = Math.max(0, Math.min(list.length - 1, (goal >= 0 ? goal : at) + dir));
      goal = i;
      alignTries = 0;
      feed.scrollTo({ top: topOf(i), behavior: 'smooth' });
    }

    // exact height of one video (phones have fractions of a pixel; 100 videos x 0.4px would drift)
    function slideH() { return feed.getBoundingClientRect().height || feed.clientHeight || 1; }
    function topOf(i) {
      var s = feed.querySelector('.hn-reel[data-i="' + i + '"]');
      return s ? s.offsetTop : i * slideH();
    }
    function nearest() {
      return Math.max(0, Math.min(list.length - 1, Math.round(feed.scrollTop / slideH())));
    }
    function later(ms) {
      clearTimeout(alignTimer);
      alignTimer = setTimeout(align, ms);
    }
    // the snap guard: if the feed rests between two videos, glide to the nearer one (2 tries, then jump)
    function align() {
      if (!el || el.hidden || touching) return;
      var i = nearest();
      var target = topOf(i);
      if (Math.abs(feed.scrollTop - target) <= 2) { alignTries = 0; goal = -1; if (i !== at) settle(i); return; }
      if (alignTries < 2) {
        alignTries++;
        feed.scrollTo({ top: target, behavior: 'smooth' });
        later(450);
      } else {
        alignTries = 0;
        feed.scrollTop = target;
        settle(i);
      }
    }
    // the screen changed size (phone toolbar, turned sideways): stay exactly on the same video
    function jump() {
      if (!el || el.hidden || touching || at < 0) return;
      feed.scrollTop = topOf(at);
    }
    // play the video on screen; if the phone refuses to play WITH sound (it can after a while in the background),
    // play it without sound instead of showing a frozen picture
    function playNow(v) {
      v.muted = muted;
      var p = v.play();
      // if the phone stops a video the moment it gets its sound (no permission for sound yet), go on without sound
      // instead of a frozen picture (our own pauses: the pause button, another video, a hidden page are not this)
      if (!muted) {
        var guard = function () {
          if (v.muted || paused || document.hidden || !el || el.hidden || v !== current()) return;
          muted = true;
          v.muted = true;
          sound();
          v.play().catch(function () {});
        };
        v.addEventListener('pause', guard, { once: true });
        setTimeout(function () { v.removeEventListener('pause', guard); }, 800);
      }
      if (!p || !p.catch) return;
      p.catch(function (err) {
        if (!err || err.name !== 'NotAllowedError' || v.muted) return; // a tap starts it
        muted = true;
        v.muted = true;
        sound();
        v.play().catch(function () {});
      });
    }

    function sound() {
      var b = el.querySelector('.hn-reels__sound');
      b.innerHTML = muted ? ICON.mute : ICON.sound;
      b.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
      b.setAttribute('aria-pressed', muted ? 'false' : 'true');
    }

    // Tap on the video / the pause button / K or Space: pause and play (a big play sign stays while paused)
    function setPaused(on, quiet) {
      paused = on;
      var b = el.querySelector('.hn-reels__pause');
      b.innerHTML = on ? ICON.play : ICON.pause;
      b.setAttribute('aria-label', on ? 'Play video' : 'Pause video');
      feed.querySelectorAll('.hn-reel--paused').forEach(function (s) { s.classList.remove('hn-reel--paused'); });
      var v = current();
      if (!v) return;
      var flash = v.closest('.hn-reel').querySelector('.hn-reel__flash');
      if (on) {
        flash.classList.remove('hn-reel__flash--on');
        flash.innerHTML = ICON.play;
        v.closest('.hn-reel').classList.add('hn-reel--paused');
      }
      if (quiet) return;
      if (on) v.pause(); else playNow(v);
    }

    function toggleSound() {
      muted = !muted;
      store('sessionStorage', SOUND_KEY, muted ? '0' : '1');
      el.querySelector('.hn-reels__sound').classList.remove('hn-reels__sound--hint');
      var cur = current();
      // only the video on screen gets the sound; the ones getting ready below the screen stay silent (they get it on screen)
      feed.querySelectorAll('video').forEach(function (v) { v.muted = v === cur ? muted : true; });
      if (cur && cur.paused && !paused) cur.play().catch(function () {});
      var flash = cur && !paused && cur.closest('.hn-reel').querySelector('.hn-reel__flash'); // paused: the play sign stays
      if (flash) {
        flash.innerHTML = muted ? ICON.mute : ICON.sound;
        flash.classList.remove('hn-reel__flash--on');
        void flash.offsetWidth;
        flash.classList.add('hn-reel__flash--on');
      }
      sound();
      bless();
    }

    function say(text) {
      toast.textContent = text;
      toast.hidden = false;
      clearTimeout(say.t);
      say.t = setTimeout(function () { toast.hidden = true; }, 2200);
    }

    function share(v) {
      var url = location.origin + '/products/' + v.h;
      var data = { title: v.product.t + ' | Haye Nii', text: v.product.t + ' by Haye Nii', url: url };
      if (navigator.share) {
        navigator.share(data).catch(function () { /* closed by the shopper */ });
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, function () { say(url); });
        return;
      }
      say(url);
    }

    function onClick(event) {
      var t = event.target;
      // fix 2026-10-20: a tap that ends a drag / a swipe, or lands while the reviews slide away, never opens a product
      if (Date.now() < quietUntil || (t.closest('a') && Date.now() < linkQuietUntil)) { event.preventDefault(); return; }
      bless();
      if (t.closest('.hn-reels__close')) return close();
      if (t.closest('.hn-reels__photo-close') || t === photo) return closePhoto();
      if (t.closest('.hn-reels__sheet-close')) return closeSheet();
      if (t.closest('.hn-reels__grab')) return setFull(!tall);
      var pic = t.closest('.hn-cmt__pic');
      if (pic) return openPhoto(pic);
      var stepBtn = t.closest('.hn-reels__step');
      if (stepBtn) return go(+stepBtn.dataset.step);
      if (t.closest('[data-sound]')) return toggleSound();
      if (t.closest('[data-pause]')) return setPaused(!paused);
      var rv = t.closest('[data-reviews]');
      if (rv) return openSheet(list[at], rv.dataset.rid || '', rv.hnReview || null, rv);
      if (t.closest('[data-share]')) return share(list[at]);
      var shop = t.closest('.hn-reel__prod, .hn-reels__sheet-shop');
      if (shop && shop.pathname === location.pathname) {
        event.preventDefault();
        close();
        setTimeout(toBuy, 350); // after the Back step of closing has settled
        return;
      }
      if (t.closest('a')) return; // product: go to the product page
      if (sheetOpen() && !t.closest('.hn-reels__sheet')) return closeSheet(); // a tap on the small video
      if (t.closest('.hn-reel__video, .hn-reel__poster, .hn-reel__tap')) {
        if (hold.used) { hold.used = false; return; } // it was a press-and-hold or a swipe, not a tap
        setPaused(!paused);
      }
    }

    // the product page's options + Add to cart (Sense: product info column)
    function toBuy() {
      var target = document.querySelector('.product__info-container variant-selects, .product__info-container .product-form__input, .product__info-container product-form, product-form');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function current() {
      var s = feed.querySelector('.hn-reel[data-i="' + at + '"]');
      return s && s.querySelector('video');
    }

    function onKey(event) {
      if (!el || el.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (!photo.hidden) return closePhoto();
        return sheetOpen() ? closeSheet() : close();
      }
      if (event.key === 'Tab') { // keyboard focus stays inside what is open on top (photo, reviews, or the videos)
        var box = !photo.hidden ? photo : sheetOpen() && !el.classList.contains('hn-reels--side') ? sheet : el;
        var f = [].filter.call(box.querySelectorAll('button, a[href]'), function (b) {
          return !b.disabled && b.offsetParent !== null && !b.closest('[hidden]') && getComputedStyle(b).visibility !== 'hidden';
        });
        if (!f.length) return;
        if (event.shiftKey && document.activeElement === f[0]) { event.preventDefault(); f[f.length - 1].focus(); }
        else if (!event.shiftKey && document.activeElement === f[f.length - 1]) { event.preventDefault(); f[0].focus(); }
        return;
      }
      if (sheetOpen() || !photo.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === 'ArrowRight') { event.preventDefault(); go(1); }
      if (event.key === 'ArrowUp' || event.key === 'PageUp' || event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
      if (event.key === 'm' || event.key === 'M') toggleSound();
      // a volume-up key (keyboards, some Android browsers) = sound on; iPhone Safari never passes it to a page
      if ((event.key === 'AudioVolumeUp' || event.key === 'VolumeUp') && muted) toggleSound();
      var onCtrl = event.target.closest && event.target.closest('button, a');
      if (event.key === 'k' || event.key === 'K' || (event.key === ' ' && !onCtrl)) { event.preventDefault(); setPaused(!paused); }
    }

    // ---------- reviews sheet ("comments") ----------
    var sheetFor = null;
    function openSheet(v, pin, pinned, from) { // pin = the review tapped under the video: shown first
      var p = v.rev || v.product;
      var c = v.card || v.product; // the piece the Shop row opens (same as the card on the video)
      var opening = !sheetOpen();
      clearTimeout(sheetTimer);
      sheet.hidden = false;
      if (from) sheetBtn = from;
      sheet.querySelector('.hn-reels__sheet-title').textContent = 'Reviews';
      var avg = parseFloat(p.r) > 0 ? Math.floor(parseFloat(p.r) * 10) / 10 : 0; // cut, never rounded up (4.96 -> 4.9)
      // the Shop row names the piece; the line under "Reviews" names the listing the reviews belong to only when that
      // is another listing of the same necklace (family pages), so it is always clear whose reviews these are
      var sub = (p !== c ? p.t : '') + (avg && p.c ? (p !== c ? ' · ' : '') + avg.toFixed(1) + ' ★ average' : '');
      var subEl = sheet.querySelector('.hn-reels__sheet-sub');
      subEl.textContent = sub;
      subEl.hidden = !sub;
      var shopEl = sheet.querySelector('.hn-reels__sheet-shop');
      shopEl.setAttribute('href', '/products/' + (v.cardH || v.h));
      shopEl.querySelector('.hn-reels__sheet-shop-name').textContent = c.t;
      shopEl.setAttribute('aria-label', 'Shop the ' + c.t);
      var img = shopEl.querySelector('img');
      if (c.i) { if (img.getAttribute('src') !== c.i) img.setAttribute('src', c.i); img.hidden = false; } else img.hidden = true;
      var listEl = sheet.querySelector('.hn-reels__sheet-list');
      listEl.scrollTop = 0;
      if (opening) showSheet();
      sheet.querySelector('.hn-reels__sheet-close').focus({ preventScroll: true });
      var A = api();
      var s = reviewsFor(p);
      if (!A || !s) { listEl.innerHTML = '<p class="hn-reels__note">Reviews couldn’t load. Please try again.</p>'; return; }
      sheetFor = s;
      var shown = 0;
      function head() {
        var n = s.total || s.list.length;
        return '<p class="hn-reels__sheet-count">' + n + (n === 1 ? ' review' : ' reviews') + (s.done ? '' : ' · loading more…') + '</p>';
      }
      function add(batch) {
        if (sheetFor !== s || sheet.hidden) return;
        if (s.failed) { listEl.innerHTML = '<p class="hn-reels__note">Reviews couldn’t load. Check your connection and tap Reviews again.</p>'; return; }
        if (!s.first) return;
        if (!s.list.length) { listEl.innerHTML = '<p class="hn-reels__note">No reviews yet for this piece.</p>'; return; }
        if (!shown) {
          listEl.innerHTML = head() + '<div class="hn-reels__cmts"></div>';
          batch = s.list; // everything that is already in
          // the tapped top comment comes from another listing of the same necklace: show it first anyway
          if (pinned && pin && !s.list.some(function (x) { return x.id === pin; })) {
            listEl.querySelector('.hn-reels__cmts').insertAdjacentHTML('beforeend', comment(pinned, A, true));
          }
        }
        listEl.querySelector('.hn-reels__sheet-count').outerHTML = head();
        if (batch.length) {
          newestFirst(listEl.querySelector('.hn-reels__cmts'), batch, pin, A);
          shown += batch.length;
        }
      }
      s.listeners = s.listeners.filter(function (fn) { return !fn.hnSheet; });
      add.hnSheet = true;
      s.listeners.push(add);
      if (s.first) add(s.list);
      else listEl.innerHTML = '<p class="hn-reels__note">Loading reviews…</p>';
      if (s.failed) listEl.innerHTML = '<p class="hn-reels__note">Reviews couldn’t load. Check your connection and tap Reviews again.</p>';
    }
    // Owner 2026-10-20: newest reviews first, no sort or filter button. Judge.me sends them newest first, 20 at a time,
    // but two pages load at once and can arrive out of order, so each review goes in at its place by date. The review
    // the shopper tapped under the video (the "top comment") stays on top.
    function stamp(r) { return r.date && !isNaN(r.date) ? +r.date : 0; }
    function newestFirst(box, batch, pin, A) {
      batch.slice().sort(function (a, b) { return stamp(b) - stamp(a); }).forEach(function (r) {
        if (box.querySelector('.hn-cmt[data-id="' + String(r.id).replace(/"/g, '') + '"]')) return; // already shown (pinned)
        var top = !!pin && r.id === pin, t = stamp(r), kids = box.children, before = null;
        if (top) before = kids[0] || null;
        else if (kids.length && +kids[kids.length - 1].dataset.t < t) { // not simply the oldest so far: find its place
          for (var k = 0; k < kids.length; k++) if (!kids[k].dataset.pin && +kids[k].dataset.t < t) { before = kids[k]; break; }
        }
        var html = comment(r, A, top);
        if (before) before.insertAdjacentHTML('beforebegin', html); else box.insertAdjacentHTML('beforeend', html);
      });
    }
    function comment(r, A, pinTop) {
      var name = String(r.name || '').trim();
      if (!name || /@|\d{3,}/.test(name)) name = 'Customer';
      var pics = r.photos.slice(0, 4).map(function (src, n) {
        return '<button type="button" class="hn-cmt__pic" data-big="' + esc(A.size(src, 1080)) + '" data-n="' + n + '" aria-label="Open photo ' + (n + 1) + ' from ' + esc(name) + '">' +
          '<img src="' + esc(A.size(src, 240)) + '" alt="" loading="lazy" decoding="async"></button>';
      }).join('');
      return '<article class="hn-cmt" data-id="' + esc(r.id || '') + '" data-t="' + stamp(r) + '"' + (pinTop ? ' data-pin="1"' : '') + '><span class="hn-cmt__avatar" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span>' +
        '<div class="hn-cmt__body"><p class="hn-cmt__head"><b>' + esc(name) + '</b>' + (A.when(r) ? ' <time>' + A.when(r) + '</time>' : '') + '</p>' +
        A.stars(r.score) +
        (r.title ? '<p class="hn-cmt__title">' + esc(r.title) + '</p>' : '') +
        (r.body ? '<p class="hn-cmt__text">' + esc(r.body) + '</p>' : '') +
        (pics ? '<div class="hn-cmt__pics">' + pics + '</div>' : '') + '</div></article>';
    }
    // The video makes room (owner 2026-10-19: "the video gets hidden under comments"). Like Instagram / TikTok:
    // - phones and tablets: the sheet opens on the lower 58% and the video on screen shrinks into the space above it,
    //   centred. It is scaled as it is (same picture, only smaller), never cropped: the jewelry can be anywhere in the
    //   video. Only transform is animated (GPU), so nothing on the page is laid out again.
    //   The words and buttons on the video fade out while it is small; the sheet has its own Shop row (at its bottom).
    // - computers (mouse) when there is room: the reviews open BESIDE the video, which keeps its size; the two slide
    //   together to the centre.
    // The video keeps playing with the same sound. While the reviews are open the feed stands still: a tap or a swipe
    // on the small video, the X, Esc, Back, or dragging the sheet down closes them.
    // iPhone fix 2026-10-20 (owner's iPhone: Safari "A problem repeatedly occurred" while opening / closing the
    // reviews): the first build scaled the whole scrolling feed (201 videos tall) and switched its touch mode. iPhone
    // Safari draws a scrolling box with its own native scroller; resizing it like that is heavy and risky. Now only the
    // picture of the ONE video on screen (its cover, its player, its tap area) is scaled; the feed and the video's own
    // frame never change (a scaled frame also moved the feed's snap point, so the feed scrolled a little on every open),
    // and the feed's scrolling is held still by a touch listener that exists only while the reviews are open. Phones turned sideways
    // keep the reviews over the video (as before release 5): nothing around the feed moves on a touch screen.
    // Round 3 (owner 2026-10-20, "like Instagram / TikTok"): swipe the sheet UP to read all reviews at full height, swipe
    // down to go back to half, or further to close; a tap on the handle does the same. The sheet is always laid out at
    // full height and "half" is the same sheet moved down (transform only), so switching never lays the page out
    // mid-move. The Shop row stays on the bottom edge of the screen in both heights.
    var SHEET_MS = 320, SIDE_W = 400;
    var sheetTimer = 0, sheetBtn = null, roomAt = null, roomEl = null;
    var quietUntil = 0, linkQuietUntil = 0;
    var tall = false; // the sheet is at full height
    var geo = { off: 0, all: 0, half: 0 }; // off = how far "half" sits below "full"; all = sheet height; half = its visible part
    function quiet() { quietUntil = Date.now() + 450; } // the click a phone may send after a drag / swipe is ignored
    function sheetOpen() { return !!el && el.classList.contains('hn-reels--sheet'); }
    function stage() { return el.querySelector('.hn-reels__stage'); }
    function holdFeed(event) { if (sheetOpen() && event.cancelable) event.preventDefault(); } // no scrolling while open
    function sideMode() { return el.classList.contains('hn-reels--side'); }
    function showSheet() {
      el.classList.remove('hn-reels--sheet-out');
      var mouse = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      el.classList.toggle('hn-reels--side', mouse && window.innerWidth >= 750 && el.clientWidth - stage().offsetWidth >= SIDE_W + 144);
      tall = false;
      sheet.style.transform = '';
      void sheet.offsetHeight; // the sheet's start (below the screen) is drawn first, then it slides in
      el.classList.add('hn-reels--sheet');
      feed.addEventListener('touchmove', holdFeed, { passive: false });
      stopHint();
      makeRoom();
    }
    // the sheet's heights (they change with the screen: phone toolbar, turning the phone)
    function measure() {
      var H = feed.clientHeight;
      geo.all = sheet.offsetHeight;
      var landscape = H <= 500 && window.innerWidth > H;
      geo.half = Math.min(geo.all, Math.round(H * (landscape ? 0.88 : 0.58)));
      geo.off = Math.max(0, geo.all - geo.half);
    }
    // where the video goes while the reviews are open
    function makeRoom() {
      if (sideMode()) {
        unRoom();
        stage().style.transform = 'translate3d(' + (-SIDE_W / 2) + 'px,0,0)';
        return;
      }
      stage().style.transform = '';
      measure();
      var s0 = feed.querySelector('.hn-reel[data-i="' + at + '"]');
      var W = feed.clientWidth, H = feed.clientHeight;
      var ctrl = el.querySelector('.hn-reels__ctrl');
      var top = Math.max(0, ctrl.offsetTop - 12) + 8; // under the notch / status bar
      var room = H - geo.half - top - 8;
      if (!s0 || room < 120 || !H) unRoom(); // phone sideways: no room, the reviews cover it as before
      else {
        if (roomEl && roomEl !== s0) unRoom();
        var s = Math.min(1, room / H);
        var off = s0.offsetTop - feed.scrollTop; // ~0: the video on screen sits at the top of the feed
        roomEl = s0;
        roomEl.classList.add('hn-reel--small');
        roomAt = { x: (W - W * s) / 2, y: top - off, s: s };
      }
      settleSheet();
    }
    function unRoom() {
      if (roomEl) { roomEl.style.removeProperty('--hn-small'); roomEl.classList.remove('hn-reel--small'); }
      roomEl = null;
      roomAt = null;
    }
    // y = how far the sheet sits below its full-height place: 0 = full, geo.off = half, geo.all = closed.
    // The video follows only between half and closed (at full height the sheet covers it anyway).
    function place(y) {
      var p = Math.max(0, Math.min(1, (y - geo.off) / Math.max(1, geo.half)));
      if (roomAt && roomEl) {
        var q = 1 - p, s = roomAt.s + (1 - roomAt.s) * p;
        roomEl.style.setProperty('--hn-small', 'translate3d(' + (roomAt.x * q).toFixed(2) + 'px,' + (roomAt.y * q).toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')');
      }
      sheet.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      // the Shop row stays on the bottom edge of the screen until the sheet goes below half
      sheet.querySelector('.hn-reels__sheet-foot').style.transform = 'translate3d(0,' + (-Math.min(y, geo.off)).toFixed(1) + 'px,0)';
    }
    // the sheet rests at half or full height
    function settleSheet() {
      if (sideMode() || !sheetOpen()) return;
      place(tall ? 0 : geo.off);
      // at half height the lower part of the list is below the screen: room at its end so the last review can be read
      sheet.querySelector('.hn-reels__sheet-list').style.paddingBottom = tall ? '' : (geo.off + 12) + 'px';
      sheet.classList.toggle('hn-reels__sheet--full', tall);
      var g = sheet.querySelector('.hn-reels__grab');
      g.setAttribute('aria-expanded', tall ? 'true' : 'false');
      g.setAttribute('aria-label', tall ? 'Show fewer reviews' : 'Show all reviews');
    }
    function setFull(on) {
      if (sideMode() || !sheetOpen()) return;
      tall = !!on;
      settleSheet();
    }
    function clearSheetStyles() {
      sheet.style.transform = '';
      sheet.querySelector('.hn-reels__sheet-foot').style.transform = '';
      sheet.querySelector('.hn-reels__sheet-list').style.paddingBottom = '';
      sheet.classList.remove('hn-reels__sheet--full');
    }
    function closeSheet(now) {
      if (!sheet || sheet.hidden) return;
      clearTimeout(sheetTimer);
      if (sheetOpen()) {
        var inside = sheet.contains(document.activeElement);
        sheetFor = null;
        linkQuietUntil = Date.now() + SHEET_MS + 300; // the product card comes back under the finger: no accidental tap
        el.classList.remove('hn-reels--sheet', 'hn-reels--drag');
        el.classList.add('hn-reels--sheet-out');
        feed.removeEventListener('touchmove', holdFeed, { passive: false });
        if (roomEl) roomEl.style.removeProperty('--hn-small'); // glides back (the class stays until the sheet is gone)
        roomAt = null;
        stage().style.transform = '';
        if (!sideMode()) place(geo.all || sheet.offsetHeight); // slides down from where it is (half, full or dragged)
        tall = false;
        // keyboard: back to the button that opened the reviews
        if (inside && sheetBtn && sheetBtn.isConnected && !now) sheetBtn.focus({ preventScroll: true });
        else if (inside) feed.focus({ preventScroll: true });
      }
      if (now || REDUCED) return sheetGone();
      sheetTimer = setTimeout(sheetGone, SHEET_MS + 40);
    }
    function sheetGone() {
      clearTimeout(sheetTimer);
      if (sheetOpen()) return; // opened again meanwhile
      sheet.hidden = true;
      clearSheetStyles();
      unRoom();
      el.classList.remove('hn-reels--sheet-out', 'hn-reels--side');
    }
    // Drag the sheet (phones): up = full height, down = back to half or closed. From the handle / title / Shop row
    // always. On the list, at both heights, the list simply scrolls (owner 2026-10-20: "I want the scroll to work and
    // video in half working"); only a swipe DOWN with the list already at its top moves the sheet (full -> half -> closed).
    function dragSheet() {
      var d = null, mv = null;
      var listEl = sheet.querySelector('.hn-reels__sheet-list');
      sheet.addEventListener('touchstart', function (event) {
        d = null;
        var t = event.touches[0];
        mv = event.touches.length === 1 ? { x: t.clientX, y: t.clientY, far: false } : null;
        if (!sheetOpen() || sideMode() || event.touches.length !== 1) return;
        var inList = listEl.contains(event.target);
        if (inList && listEl.scrollTop > 0) return; // list scrolled down: the list scrolls
        d = { x: t.clientX, y: t.clientY, inList: inList, on: false, y0: tall ? 0 : geo.off, pos: tall ? 0 : geo.off, ly: t.clientY, lt: Date.now(), v: 0 };
      }, { passive: true });
      sheet.addEventListener('touchmove', function (event) {
        var t = event.touches[0];
        if (mv && t && (Math.abs(t.clientX - mv.x) > 6 || Math.abs(t.clientY - mv.y) > 6)) mv.far = true;
        if (!d || event.touches.length !== 1) return;
        var dy = t.clientY - d.y;
        if (!d.on) {
          if (Math.abs(t.clientX - d.x) > Math.abs(dy)) { d = null; return; } // sideways (a photo row): not a drag
          if (Math.abs(dy) < 8) return;
          if (d.inList && dy < 0) { d = null; return; } // swipe up on the list: the list scrolls (half or full)
          if (d.inList && listEl.scrollTop > 0 && dy > 0) { d = null; return; }
          d.on = true;
          el.classList.add('hn-reels--drag');
        }
        if (event.cancelable) event.preventDefault();
        var now = Date.now();
        if (now > d.lt) { d.v = (t.clientY - d.ly) / (now - d.lt); d.ly = t.clientY; d.lt = now; }
        var y = d.y0 + dy - (dy > 0 ? 8 : -8);
        d.pos = y < 0 ? y / 4 : Math.min(y, geo.all); // a little give above full height
        place(Math.max(d.pos, -24));
      }, { passive: false });
      var end = function (cancel, event) {
        // a finger that moved on the sheet never "taps" a link or button when lifted. Browsers do not report small moves
        // (under ~10-15 px) as touchmove and still send a click, so the start and end points are compared too
        var t = event && event.changedTouches && event.changedTouches[0];
        if (mv && t && (Math.abs(t.clientX - mv.x) > 10 || Math.abs(t.clientY - mv.y) > 10)) mv.far = true;
        if (mv && mv.far) quiet();
        mv = null;
        if (!d) return;
        var g = d;
        d = null;
        if (!g.on) return;
        el.classList.remove('hn-reels--drag');
        if (!sheetOpen()) return;
        if (cancel) return settleSheet(); // back where it was
        var y = g.pos, v = g.v; // v > 0: moving down (px per ms)
        if (v < -0.4) { tall = true; return settleSheet(); } // flick up: all reviews
        if (v > 0.5) { // flick down: from full to half, from half to closed
          if (g.y0 === 0 && y < geo.off) { tall = false; return settleSheet(); }
          return closeSheet();
        }
        if (y > geo.off + geo.half * 0.25) return closeSheet(); // dragged well below half
        // a clear pull (60 px) goes to the next height, a small one springs back (Instagram)
        tall = g.y0 === 0 ? y - g.y0 < 60 : y - g.y0 < -60;
        settleSheet();
      };
      sheet.addEventListener('touchend', function (event) { end(false, event); }, { passive: true });
      sheet.addEventListener('touchcancel', function (event) { end(true, event); }, { passive: true });
    }

    // ---------- a review photo, big ----------
    function openPhoto(btn) {
      var all = [].slice.call(btn.closest('.hn-cmt__pics').querySelectorAll('.hn-cmt__pic'));
      var strip = photo.querySelector('.hn-reels__photo-strip');
      strip.innerHTML = all.map(function (b, n) {
        return '<img src="' + esc(b.dataset.big) + '" alt="Review photo ' + (n + 1) + ' of ' + all.length + '">';
      }).join('');
      photo.hidden = false;
      photo.dataset.from = '';
      photo.hnBack = btn;
      var n = +btn.dataset.n || 0;
      strip.scrollLeft = strip.clientWidth * n;
      photo.querySelector('.hn-reels__photo-close').focus({ preventScroll: true });
    }
    function closePhoto() {
      if (!photo || photo.hidden) return;
      photo.hidden = true;
      photo.querySelector('.hn-reels__photo-strip').innerHTML = '';
      if (photo.hnBack) photo.hnBack.focus({ preventScroll: true });
    }

    return { open: open };
  })();

  // ---------- start ----------
  // shuffled, and never the same product twice in a row when another product can go there
  // after: the product just before this list (so the join is not the same piece either)
  function spread(list, after) {
    var left = shuffle(list), out = [];
    while (left.length) {
      var prev = out.length ? out[out.length - 1].h : (after || '');
      // the piece with the most videos left must go now if the others can no longer keep its videos apart
      var count = {}, top = '';
      left.forEach(function (x) { count[x.h] = (count[x.h] || 0) + 1; if (!top || count[x.h] > count[top]) top = x.h; });
      var must = top !== prev && count[top] * 2 > left.length ? top : '';
      var n = 0;
      while (n < left.length && (must ? left[n].h !== must : left[n].h === prev)) n++;
      out.push(left.splice(n < left.length ? n : 0, 1)[0]);
    }
    return out;
  }

  function init(section) {
    var products = null;
    try { products = JSON.parse(section.querySelector('[data-hn-ig-products]').textContent); } catch (e) { products = null; }
    var url = section.dataset.reels;
    var only = section.dataset.product || '';
    var mode = section.dataset.mode || (only ? 'product' : 'home');
    var fam = section.dataset.family === '1';
    // family pages: the Reviews button opens this listing's reviews, or the main "Any Language" listing's when it has none
    var famRev = fam ? ((products && products[only] && products[only].c > 0) ? products[only] : (products && products[MAIN]) || null) : null;
    var base = (url || '').split('hayenii-reels.json')[0]; // the theme's assets folder (cover pictures live there)
    function fail() { section.hidden = true; }
    if (!products || !url || !window.fetch) return fail();
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
      if (!Array.isArray(data)) return fail();
      var list = [];
      data.forEach(function (d) {
        if (d && d.g) { if (d.g === 'name-necklace' && Array.isArray(d.ok)) groupOk = d.ok; return; }
        if (d && d.ok) okFor[d.h] = d.ok;
        var p = d && products[d.h];
        if (!p || !p.t || !d.v || !(d.c || d.p)) return; // product off sale, or not shown on this page, or not ready
        if (mode === 'product' && d.h !== only) return;
        if ((mode === 'family' || mode === 'kind') && d.h === only) return;
        list.push({ h: d.h, v: d.v, cover: d.c ? base + d.c : d.p, who: d.w || 'Haye Nii', d: d.d || '', wide: !!d.wide,
          lead: !!d.lead, product: p, mode: mode, fam: fam, rev: famRev || p,
          card: mode === 'family' ? products[only] : null, cardH: mode === 'family' ? only : '' });
      });
      if (mode === 'product') {
        if (!list.length) return fail();
        var mine = list.filter(function (v) { return v.lead; }).concat(shuffle(list.filter(function (v) { return !v.lead; })));
        return row(section, mine, mine);
      }
      if (mode === 'family') {
        // one video per creator first (shuffled), then the others
        if (!list.length) return fail();
        var seen = {}, firsts = [], others = [];
        shuffle(list).forEach(function (v) { if (seen[v.who]) others.push(v); else { seen[v.who] = true; firsts.push(v); } });
        firsts = spread(firsts);
        var all = firsts.concat(spread(others, firsts.length ? firsts[firsts.length - 1].h : ''));
        return row(section, firsts, all);
      }
      if (mode === 'kind') {
        if (!list.length) return fail();
        var kl = shuffle(list.filter(function (v) { return v.lead; }));
        return row(section, kl.length ? kl : list, kl.concat(spread(list.filter(function (v) { return !v.lead; }), kl.length ? kl[kl.length - 1].h : '')));
      }
      if (list.length < 3) return fail();
      var leads = shuffle(list.filter(function (v) { return v.lead; }));
      var rest = spread(list.filter(function (v) { return !v.lead; }), leads.length ? leads[leads.length - 1].h : '');
      // the row = one clear video of each product; full screen goes on with all the other videos
      var homeFeed = leads.length >= 3 ? leads.concat(rest) : list;
      row(section, leads.length >= 3 ? leads : list, homeFeed, homeFeed);
    }).catch(fail);
  }

  function whenNear(section) {
    if (!('IntersectionObserver' in window)) return init(section);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      init(section);
    }, { rootMargin: section.dataset.product ? '400px 0px' : '900px 0px' }); // product pages: less on mobile data
    io.observe(section);
  }

  function start() { document.querySelectorAll('[data-hn-home-ig]').forEach(whenNear); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
